import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import logo from '@/containers/SubscriptionFormPageNew/Components/Contact/user.svg'
import SalesScriptContent from '@/containers/SubscriptionFormPageNew/Components/SalesScript/SalesScriptContent'
import useSalesScript from '@/containers/SubscriptionFormPageNew/Components/SalesScript/useSalesScript'
import { SpacingWrapper } from '@/shared/theme/styled-components'
import { SidebarCard } from './styled-components'

const SalesScript = () => {
  const { hidden, title, emptyText, errorText, sectionOptions, selectedSection, content, status, selectSection } =
    useSalesScript()

  if (hidden) return null

  return (
    <SidebarCard>
      <PanelNew
        alt={title}
        logo={logo}
        title={title}
        id='SalesScriptModule'
      >
        {/* @ts-expect-error SDButtonGroup is a JS component */}
        <SDButtonGroup
          options={sectionOptions}
          selectedValue={selectedSection}
          onClickHandler={selectSection}
        />
        <SpacingWrapper $marginTop='1rem'>
          <SalesScriptContent
            content={content}
            status={status}
            emptyText={emptyText}
            errorText={errorText}
          />
        </SpacingWrapper>
      </PanelNew>
    </SidebarCard>
  )
}

export default SalesScript
